import React from 'react'
import { useState, useEffect, useRef } from 'react';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';

function DailtAttendence({ adminData }) {

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };
      const { setLoading } = useLoading();

    const getCurrentDateTime = () => {
        const now = new Date();
        const istOffset = 5.5 * 60;
        const localOffset = now.getTimezoneOffset();
        const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);

        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0");
        const day = String(istTime.getDate()).padStart(2, "0");
        const hours = String(istTime.getHours()).padStart(2, "0");
        const minutes = String(istTime.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const [formData, setFormData] = useState({
        emp_id: '',
        emp_name: '',
        current_date: getCurrentDateTime(),
        type: 'Present',
        check_in: '',
        check_out: '',
        checkin_loc: '',
        checkout_loc: '',


    })
    const [attendance, setAttendance] = useState([]);
    const [error, setError] = useState("");
    const [addresses, setAddresses] = useState({});



    const displayName = `${adminData.user.first} ${adminData.user.middle ?? ""} ${adminData.user.last} - ${adminData.user.emp_id}`;

    const empId = adminData.user.emp_id;
    // const todayAttendance = attendance.length > 0 ? attendance[0] : null;


    const todayDate = new Date().toISOString().split("T")[0];
    const todayAttendance = attendance.filter(record => record.date === todayDate);


const hasCheckedInToday = attendance.some(
  (record) => record.date === todayDate
);





    navigator.geolocation.getCurrentPosition(
        (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

        },
        (error) => {
            console.error(error);
        }
    );

    navigator.geolocation.getCurrentPosition(
        async (position) => {
            const { latitude, longitude } = position.coords;
            // setLocation({ latitude, longitude });

            setLoading(false);
        },
        (err) => {
            console.error("Geolocation error:", err);
            setLoading(false);

        }
    );


    const fetchAddress = async (lat, lng) => {
        setLoading(true)
        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
            );
            const data = await response.json();
            return data.display_name || "-";
        } catch (err) {
            console.error("Error fetching address:", err);
            return "-";
        } finally {
          setLoading(false);
        } 
    };


    const handleCheckIn = () => {
        if (!navigator.geolocation) {
            showToast("Geolocation is not supported by this browser",'warning');
            return;
        }
        const now = new Date();
        const istTime = new Date(now.getTime() + 5.5 * 60 * 60 * 1000);

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const payload = {
                    type: "Present",
                    check_in: istTime.toISOString(),
                    date: formData.current_date,
                    emp_name: displayName,
                    checkin_loc: JSON.stringify({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    }),
                };

                try {
                    const res = await axios.post(`https://api.skyguard.group/api/attendance-checkin/${adminData.user.emp_id}`,
                        payload
                    );

                    showToast('Check-in successful', 'success')
                } catch (error) {
                    console.error(error);
                    showToast('Check-in failed', 'danger')
                }
            },
            (error) => {
                console.error(error);
                showToast('Location permission denied', 'warning')

            }
        );
    };



    const handleCheckOut = (attendanceId) => {
        if (!navigator.geolocation) {
            showToast("Geolocation is not supported by this browser",'warning');
            return;
        }

        const now = new Date();
        const istTime = new Date(now.getTime() + 5.5 * 60 * 60 * 1000);

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const payload = {
                    emp_id: adminData.user.emp_id,
                    check_out: istTime.toISOString(),
                    checkout_loc: JSON.stringify({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    }),
                };
                try {
                    const res = await axios.put(`https://api.skyguard.group/api/attendance-checkout/${attendanceId}`,
                        payload
                    );
                    showToast('Check-out successful', 'success')
                } catch (error) {
                    console.error(error);
                    showToast('Check-out failed', 'danger')
                }
            },
            (error) => {
                console.error(error);
                showToast('Location permission denied', 'warning')
            }
        );
    };

    useEffect(() => {

        if (empId) fetchAttendance();
    }, [empId]);

    useEffect(() => {
    fetchAttendance();
    }, []);

    const fetchAttendance = async () => {
          setLoading(true);
        try {
          
            const response = await axios.get(`https://api.skyguard.group/api/get-attendance/${empId}`);
            const data = response.data || [];
            setAttendance(response.data);

            const addrMap = {};
            await Promise.all(
                data.map(async (record) => {
                    if (record.checkin_loc) {
                        const loc = JSON.parse(record.checkin_loc);
                        addrMap[`checkin_${record.id}`] = await fetchAddress(loc.lat, loc.lng);
                    }
                    if (record.checkout_loc) {
                        const loc = JSON.parse(record.checkout_loc);
                        addrMap[`checkout_${record.id}`] = await fetchAddress(loc.lat, loc.lng);
                    }
                })
            );
            setAddresses(addrMap);
            setLoading(false);

        } catch (err) {
            console.error(err);
            setError("Failed to fetch attendance");
        } finally {
            setLoading(false);
        }
    };



    return (
        <>
            <div className='main-section'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Attendence</h3>
                    <h2 className="text-center mb-4 fw-bold text-success">
                        Daily Attendecne
                    </h2>
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-10 col-md-6 col-lg-5">
                            <div className="card shadow-sm p-4 border-0">
                                <div className="card-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-12 mb-3">
                                                <label className="form-label fw-medium">
                                                    Employee
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={displayName}
                                                    readOnly
                                                />

                                            </div>

                                            <div className="col-12 mb-3">
                                                <label className="form-label fw-medium">
                                                    Date and Time
                                                </label>
                                                <input type="datetime-local" className="form-control" name='current_date' value={formData.current_date} disabled />
                                            </div>

                                            {/* Buttons */}
                                            <div className="col-12 d-flex justify-content-end gap-2 mt-3">
                                                <button type="button" className="btn btn-success" onClick={handleCheckIn}
                                                disabled={hasCheckedInToday}
                                                >
                                                    Check In
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={() => handleCheckOut(todayAttendance.id)}
                                                    disabled={!todayAttendance || todayAttendance.check_out !== null}
                                                >
                                                    Check Out
                                                </button>


                                            </div>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>SN</th>
                                    <th>Employee Name </th>
                                    <th>Check-In</th>
                                    <th>Check-Out</th>
                                    <th>Date</th>
                                    <th>Check-In Location</th>
                                    <th>Check-Out Location</th>
                                </tr>
                            </thead>
                           

                            <tbody>
  {todayAttendance.length === 0 ? (
    <tr>
      <td colSpan={7} className="text-center">
        No attendance found for today
      </td>
    </tr>
  ) : (
    todayAttendance.map((record, idx) => (
      <tr key={record.id}>
        <td>{idx + 1}</td>
        <td>{record.emp_name}</td>
        <td>{record.check_in ? record.check_in.split(".")[0] : "-"}</td>
        <td>{record.check_out ? record.check_out.split(".")[0] : "-"}</td>
        <td>{record.date || "-"}</td>
        <td style={{ maxWidth: "250px", whiteSpace: "normal", wordBreak: "break-word", verticalAlign: "top" }}>
          {addresses[`checkin_${record.id}`] || "-"}
        </td>
        <td style={{ maxWidth: "250px", whiteSpace: "normal", wordBreak: "break-word", verticalAlign: "top" }}>
          {addresses[`checkout_${record.id}`] || "-"}
        </td>
      </tr>
    ))
  )}
</tbody>

                        </table>
                    </div>


                </div>
            </div>
        </>
    )
}

export default DailtAttendence
